<template>
<div class="talentIndex">
    
    <index-search :rolllist="rolllist"></index-search>
    <!-- end index-search 主页搜索栏 -->

    <section class="index-menu-and-swiper">
        <div class="module module2">
            <index-menulist></index-menulist>
            <!-- end  index-menulist 菜单列表 -->
            <index-swiper></index-swiper>
            <!-- end index-siwper 轮播图 -->
        </div>
    </section>
    <!-- end index-menu-and-swiper 主页菜单与轮播  -->

    <recruit-info :hotjoblist="hotjoblist" :newjoblist="newjoblist"></recruit-info>
    <!-- end recruit-info 招聘信息 -->

    <entry-list :livelist="livelist"></entry-list>
    <!-- end entry-list 实时入职榜 -->

    <host-city></host-city>
    <!-- end host-city 热招城市 -->

    <famous-cooperative-enterprises></famous-cooperative-enterprises>
    <!-- end famous-cooperative-enterprises 合作名企 -->

    <talent-button-silder></talent-button-silder>
    <!-- end talent-button-silder 猎聘侧边按钮栏 -->
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import TalentButtonSilder from './../components/TalentButtonSilder'
import IndexMenulist from './components/IndexMenulist'
import EntryList from './components/EntryList'
import FamousCooperativeEnterprises from './components/FamousCooperativeEnterprises'
import HostCity from './components/HostCity'
import IndexSwiper from './components/IndexSwiper'
import IndexSearch from './components/IndexSearch'
import RecruitInfo from './components/RecruitInfo'
import {getIndexInfo} from 'api/talent'
export default {
    name: 'TalentIndex',
    data() {
        return {
            hotjoblist: [], // 热门急招
            newjoblist: [], // 最新岗位
            livelist: [],   // 实时入职
            rolllist: []    // 搜索栏顶部滚动
        }
    },
    created() {
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MTalentIndex'
            })
        }
    },
    mounted() {
        this.initIndexInfo()
    },
    methods: {
        initIndexInfo() {   // 初始化首页数据
            this.setLoading(true)
            getIndexInfo({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.hotjoblist = data.data.hotjoblist
                    this.newjoblist = data.data.newjoblist
                    this.rolllist = data.data.rolllist

                    // 判断实时入职的数据条数，未满50条则补全为50条
                    this.livelist = data.data.livelist
                    let livelen = this.livelist.length
                    if (livelen < 50 && livelen > 0) {
                        for (let i = 0; i < Math.ceil(50 / livelen); i++) {
                            let clivelist = this.livelist.concat(data.data.livelist)
                            this.livelist = clivelist
                        }
                    }
                    console.log(data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {
        TalentButtonSilder,IndexMenulist,EntryList,FamousCooperativeEnterprises,HostCity,IndexSearch,RecruitInfo,IndexSwiper
    }
}
</script>

<style lang="scss" type="text/scss">
.talentIndex {
    .module {
        margin: auto;
        max-width: 1200px;
    }
    .module2 {
        background-color: #FFF;
        // background-color: rgb(140, 218, 198);
    }

    .index-menu-and-swiper {
        padding-top: 30px;
        height: 352px;
        background: #fff;
    }
}
</style>